import { NavigationMenuRoutes } from "@lib/base/components/navigation/navigation-menu/navigation-menu.types";

export const APP_NAVIGATION: NavigationMenuRoutes[] = [
    {
        key: "routing.workspace._title",
        route: "/workspace",
        icon: "work",
        hideIfAlone: true,
    },
    {
        key: "routing.administration-ubi._title",
        route: "/administration-ubi",
        icon: "business",
        SuperAdminOnly: true,
    },
    {
        key: "routing.administration._title",
        route: "/administration",
        icon: "business",
        allAbsoluteReadPermission: [
            "Station",
            "Tag",
        ],
    },
];
